"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

var _topicService = require("../services/topicService");

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

var _button = require("@insided/deprecated-preact-components/design-system-components/button");

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _AuthorSelect = _interopRequireDefault(require("@insided/deprecated-control/author-select/AuthorSelect"));

var _inputUnit = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/input-unit"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ChangeAuthorModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ChangeAuthorModal, _PureComponent);

  var _super = _createSuper(ChangeAuthorModal);

  function ChangeAuthorModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ChangeAuthorModal);
    _this = _super.call(this, props);
    _this.onSelectAuthor = _this.onSelectAuthor.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSaveChangedAuthor = _this.onSaveChangedAuthor.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ChangeAuthorModal, [{
    key: "onSelectAuthor",
    value: function onSelectAuthor(author) {
      this.setState({
        selectedAuthor: author
      });

      if (this.state.errorMessage) {
        this.setState({
          errorMessage: undefined
        });
      }
    }
  }, {
    key: "onSaveChangedAuthor",
    value: function () {
      var _onSaveChangedAuthor = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this$props, contentType, topicId, onChangeAuthor, onClose, onShowAlert, selectedAuthor, newAuthorId, _yield$getTopic, _author;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, contentType = _this$props.contentType, topicId = _this$props.topicId, onChangeAuthor = _this$props.onChangeAuthor, onClose = _this$props.onClose, onShowAlert = _this$props.onShowAlert;
                selectedAuthor = this.state.selectedAuthor;

                if (selectedAuthor) {
                  _context.next = 5;
                  break;
                }

                this.setState({
                  errorMessage: 'Please select a user'
                });
                return _context.abrupt("return");

              case 5:
                this.setState({
                  isLoading: true
                });
                _context.prev = 6;
                newAuthorId = Number(selectedAuthor.id);
                _context.next = 10;
                return (0, _topicService.changeAuthor)(contentType, topicId, newAuthorId);

              case 10:
                _context.next = 12;
                return (0, _topicService.getTopic)(contentType, topicId);

              case 12:
                _yield$getTopic = _context.sent;
                _author = _yield$getTopic.author;
                onChangeAuthor(_author);
                onClose();
                onShowAlert === null || onShowAlert === void 0 ? void 0 : onShowAlert('success', 'You’ve changed the author successfully.');
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](6);
                onShowAlert === null || onShowAlert === void 0 ? void 0 : onShowAlert('error');

              case 22:
                this.setState({
                  isLoading: false
                });

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 19]]);
      }));

      function onSaveChangedAuthor() {
        return _onSaveChangedAuthor.apply(this, arguments);
      }

      return onSaveChangedAuthor;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var onClose = this.props.onClose;
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          selectedAuthor = _this$state.selectedAuthor,
          errorMessage = _this$state.errorMessage;
      return (0, _preact.h)(_modal.default, {
        onClose: onClose,
        isControl: true
      }, (0, _preact.h)(_modal.ModalHeader, {
        title: "Change author"
      }), (0, _preact.h)(_modal.ModalBody, null, (0, _preact.h)(_inputUnit.default, {
        label: "Author",
        error: errorMessage
      }, (0, _preact.h)(_AuthorSelect.default, {
        selected: selectedAuthor,
        onChange: function onChange(author) {
          return _this2.onSelectAuthor(author);
        }
      }))), (0, _preact.h)(_modal.ModalFooter, null, (0, _preact.h)(_button.ButtonGroup, null, (0, _preact.h)(_buttonControl.default, {
        title: "Change author",
        variant: "brand",
        onClick: this.onSaveChangedAuthor,
        isLoading: isLoading,
        class: "qa-change-author",
        newStyle: true,
        size: "medium"
      }), (0, _preact.h)(_buttonControl.default, {
        title: "Cancel",
        onClick: onClose,
        newStyle: true,
        size: "medium"
      }))));
    }
  }]);
  return ChangeAuthorModal;
}(_preactCompat.PureComponent);

var _default = ChangeAuthorModal;
exports.default = _default;